import { trackEvent } from '../analyticsService';
import { NAVIGATION_EVENTS } from '../events';

const MODULE_NAME = 'navigation';

export function useNavigationAnalytics() {
  const trackAppNavigationClicked = (payload = {}) => {
    trackEvent(NAVIGATION_EVENTS.APP_NAVIGATION_CLICKED, {
      module_name: MODULE_NAME,
      source: payload.source || payload.sourcePosition || payload.source_position,
      source_position: payload.sourcePosition || payload.source_position || payload.source,
      event_label: payload.eventLabel || payload.event_label,
      element_name: payload.elementName || payload.element_name,
      element_type: payload.elementType || payload.element_type,
      target_route_name: payload.targetRouteName || payload.target_route_name,
      target_route_type: payload.targetRouteType || payload.target_route_type || 'internal',
      method: payload.method || 'user_click',
      lang: payload.lang,
      is_logged_in: payload.isLoggedIn ?? payload.is_logged_in
    });
  };

  const trackUiPreferenceChanged = (payload = {}) => {
    trackEvent(NAVIGATION_EVENTS.UI_PREFERENCE_CHANGED, {
      module_name: MODULE_NAME,
      source_position: payload.sourcePosition || payload.source_position,
      event_label: payload.eventLabel || payload.event_label || 'ui_preference_changed',
      element_name: payload.elementName || payload.element_name,
      element_type: payload.elementType || payload.element_type,
      method: payload.method || 'user_click',
      option_name: payload.optionName || payload.option_name,
      option_value: payload.optionValue || payload.option_value,
      previous_value: payload.previousValue || payload.previous_value,
      lang: payload.lang,
      is_logged_in: payload.isLoggedIn ?? payload.is_logged_in
    });
  };

  const trackLanguageChanged = ({ fromLang, toLang, source } = {}) => {
    trackEvent(NAVIGATION_EVENTS.LANGUAGE_CHANGED, {
      from_lang: fromLang,
      to_lang: toLang,
      source
    });
  };

  // 原 trackLogoClicked（logo_clicked）已删除：事件定义与其唯一字段（裸 `source`）不合规，
  // 且 Logo 点击现已由各使用方按自身事件域上报 —— App header / Login 走 trackAppNavigationClicked，
  // Landing header 走 trackLandingNavClicked。勿在此处重新引入。
  return {
    trackAppNavigationClicked,
    trackUiPreferenceChanged,
    trackLanguageChanged
  };
}
